.main-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 calc(var(--spacer) * 5);
  color: var(--chart-302-icon-buttons-titles);
  border-bottom: 1px solid var(--chart-101-pressed-dividers);

  gz-text {
    color: var(--chart-302-icon-buttons-titles);
    line-height: 18px;
    width: fit-content;
  }
}

